import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../redux/rootReducer";
import { AppThunk } from "../../../../redux/store";
import { handleError } from "../../../../utils/helpers/helpers";
import InvitationsService from "../services/invitationsService";

export interface InvitationsError {
  message?: string;
  statusCode?: number;
}

export interface InvitationsState {
  invitations: any;
  loading: boolean;
  error: InvitationsError | null;
  userExist?: boolean | null;
}

export const initialState: InvitationsState = {
  invitations: [],
  loading: false,
  userExist: null,
  error: {
    message: null,
    statusCode: null,
  },
};

export const invitationsSlice = createSlice({
  name: "invitations",
  initialState,
  reducers: {
    setInvitationsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setInvitationsFailed: (
      state,
      { payload }: PayloadAction<InvitationsError>
    ) => {
      state.loading = false;
      state.error.message = payload.message;
      state.error.statusCode = payload.statusCode;
    },
    setUserExist: (state, { payload }: PayloadAction<boolean>) => {
      state.userExist = payload;
    },
  },
});

export const { setInvitationsLoading, setInvitationsFailed, setUserExist } =
  invitationsSlice.actions;

export const acceptInvitationAction =
  (uuid: string): AppThunk =>
  async (dispatch) => {
    try {
      dispatch(setInvitationsLoading(true));
      let resp = await InvitationsService.acceptInvitation(uuid);
      if (resp.data?.user?.email !== undefined) {
        await dispatch(setUserExist(true));
      } else {
        await dispatch(setUserExist(false));
      }
    } catch (e) {
      dispatch(setInvitationsFailed(e.response.data));
      handleError(e);
      dispatch(setUserExist(true));
    } finally {
      dispatch(setInvitationsLoading(false));
      dispatch(setUserExist(true));
    }
  };

export const invitationsSelector = (state: RootState) => state.invitations;
export default invitationsSlice.reducer;
